export default {
  en: 'English',
  ar: 'عربي (Arabic)',
};
